export enum EvaluationType {
  DEVOIR = 'DEVOIR',
  COMPOSITION = 'COMPOSITION',
  CONTROLE = 'CONTROLE',
}

export interface IEvaluation {
  id?: string;
  titre?: string;
  numero?: number | null;
  date?: string | null;
  bareme?: number | null;
  type?: EvaluationType | null;
  ecoleId?: string;
  anneeScolaireId?: string;
  classeId?: string;
  classeNom?: string | null;
  matiereId?: string;
  matiereNom?: string | null;
  sousMatiereId?: string | null;
  sousMatiereNom?: string | null;
  professeurId?: string | null;
  periodeId?: string;
}

export const defaultValue: Readonly<IEvaluation> = {
  id: '',
  titre: '',
  numero: null,
  date: null,
  bareme: null,
  type: null,
  ecoleId: '',
  anneeScolaireId: '',
  classeId: '',
  classeNom: null,
  matiereId: '',
  matiereNom: null,
  sousMatiereId: null,
  sousMatiereNom: null,
  professeurId: '',
  periodeId: '',
};
